import { produce } from 'immer';
import { handleActions } from 'redux-actions';
import { conversationsOverviewActions } from '../actions/conversationsOverview';
const { conversationsOverviewReset, conversationsOverviewGetMessages, conversationsOverviewGetMessagesSucceeded, conversationsOverviewGetMessagesFailed, conversationsOverviewSelectionAdd, conversationsOverviewSelectionRemove, conversationsOverviewSelectionClear, conversationsOverviewFetchBulkIds, conversationsOverviewFetchBulkIdsFailed, conversationsOverviewFetchBulkIdsSave, } = conversationsOverviewActions;
const initialBulkState = {
    selectedConversations: [],
    bulkCurrentQueryFilter: null,
    bulkValidation: [],
    bulkAllIDs: [],
    bulkTotalConversations: null,
    bulkIDsStatus: 'succeeded',
};
const initialState = Object.assign({ meta: {
        getMessagesAsyncStatus: 'succeeded',
    }, messages: [] }, initialBulkState);
const conversationsOverview = handleActions({
    [conversationsOverviewReset.toString()]: () => initialState,
    [conversationsOverviewGetMessages.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getMessagesAsyncStatus: 'loading' }), messages: [] });
    },
    [conversationsOverviewGetMessagesSucceeded.toString()]: (state, action) => {
        const messages = action.payload.data.messages.slice();
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getMessagesAsyncStatus: 'succeeded' }), messages: messages });
    },
    [conversationsOverviewGetMessagesFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getMessagesAsyncStatus: 'failed' }) });
    },
    [conversationsOverviewSelectionAdd.toString()]: (state, action) => {
        return produce(state, (draftState) => {
            const { csids } = action.payload;
            csids.forEach((ID) => {
                if (ID && draftState.selectedConversations.indexOf(ID) === -1) {
                    draftState.selectedConversations.push(ID);
                }
            });
        });
    },
    [conversationsOverviewSelectionRemove.toString()]: (state, action) => {
        return produce(state, (draftState) => {
            const { csids } = action.payload;
            csids.forEach((ID) => {
                if (ID) {
                    const removalIndex = draftState.selectedConversations.indexOf(ID);
                    if (removalIndex !== -1) {
                        draftState.selectedConversations.splice(removalIndex, 1);
                    }
                }
            });
        });
    },
    [conversationsOverviewSelectionClear.toString()]: (state) => {
        return produce(state, (draftState) => {
            draftState.selectedConversations = initialState.selectedConversations;
        });
    },
    [conversationsOverviewFetchBulkIds.toString()]: (state) => {
        return produce(state, (draftState) => {
            draftState.bulkIDsStatus = 'loading';
        });
    },
    [conversationsOverviewFetchBulkIdsFailed.toString()]: (state) => {
        return produce(state, (draftState) => {
            draftState = Object.assign(Object.assign(Object.assign({}, state), initialBulkState), { bulkIDsStatus: 'failed' });
        });
    },
    [conversationsOverviewFetchBulkIdsSave.toString()]: (state, action) => {
        return produce(state, (draftState) => {
            const { payload: { queryFilter, data }, } = action;
            const { csids, validations_failed, total_conversations } = data;
            draftState.bulkCurrentQueryFilter = queryFilter;
            draftState.bulkValidation = validations_failed;
            draftState.bulkAllIDs = csids;
            draftState.bulkTotalConversations = total_conversations;
            draftState.bulkIDsStatus = 'succeeded';
        });
    },
}, initialState);
export default conversationsOverview;
